import './ImageBlock.scss';
import ImageResponsive from '../contentful/ImageResponsive';
import React from 'react';

class ImageBlock extends React.Component {
  constructor(props) {
    super(props);

    this.getBlockInfo = this.getBlockInfo.bind(this);
    this.showUrlModal = this.showUrlModal.bind(this);
  }

  showUrlModal(e) {
    e.preventDefault();

    this.props.blockProps.urlEditor(this.getBlockInfo());
  }

  getBlockInfo() {
    const {block, contentState, blockProps} = this.props;

    const targetBlock = block.getEntityAt(0);
    if (!targetBlock) {
      // Prevent creation of new invalid block when pressing Enter inside this block
      // TODO: Prevent this some other way?
      return null;
    }

    const data = contentState.getEntity(targetBlock).getData();
    let url = data.url;
    let urlInTab = data.urlInTab;

    if (blockProps.url !== undefined && blockProps.url !== null) {
      url = blockProps.url;
    }
    if (blockProps.urlInTab !== undefined && blockProps.urlInTab !== null) {
      urlInTab = blockProps.urlInTab;
    }

    return {
      block,
      contentState,
      data,
      url,
      urlInTab
    };
  }

  render() {
    const blockInfo = this.getBlockInfo();

    if (!blockInfo) {
      return null;
    }

    if (!blockInfo.data.image) {
      return <p>Bilde mangler</p>;
    }

    return (
      <div className={`image-block ${blockInfo.url && 'image-block-link'}`} data-url={blockInfo.url}>
        <ImageResponsive
          url={blockInfo.url}
          src={blockInfo.data.image.url}
          width={blockInfo.data.image.details.image.width}
          height={blockInfo.data.image.details.image.height}
        />
        <div className="image-block-action-buttons">
          <button className="image-block-link-button btn btn-primary" onClick={this.showUrlModal}><i className="fa fa-external-link" aria-hidden="true"></i> Lenke</button>
        </div>
      </div>
    );
  }
}

export default ImageBlock;
